export default {
  // Tooltip 内容
  aiModel: "AI模型",
  dataUpdate: "数据更新",
  canvasFilter: "画布筛选",
  historyRecord: "历史记录",
  investigation: "调证",
  sameIpTime: "同时段同IP",

  // 数据更新面板
  dataUpdateTitle: "数据更新",
  updateInstruction: "点击右边更新按钮可更新",
  investigationData: "调证数据",
  labelRemarks: "标签备注",
  addressBalance: "地址余额",
  lastUpdate: "上次更新：{time}",

  // 余额更新对话框
  balanceDialogTitle: "提示",
  balanceDialogContent:
    "当前画布地址共{count}个，更新余额需要较长的时间，请耐心等待！",
  cancel: "取 消",
  confirm: "确 定",

  // 消息提示
  queryingBalance: "正在查询余额中请稍后",
  queryingData: "正在查询数据中请稍后",
  queryingLabels: "正在查询标签中请稍后",
  updateSuccess: "更新成功",

  // 配置确认对话框
  configConfirmTitle: "提示",
  configConfirmMessage: "是否修改当前配置?",
  confirmButton: "确定",
  cancelButton: "取消",
  configUpdateSuccess: "修改配置成功",
  configUpdateCanceled: "已取消修改",

  // 其他
  investigationDetails: "调证详情",
};
